import { Card } from '@components/atoms/Card';
import Alert from '@components/atoms/Alert';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { formatActivityTime } from '@utils/formatDate';
import { ActivityHeader } from '../ActivityHeader';
import { TaskName } from '../TaskName';
import { useTranslation } from '@hooks/useTranslation';

export const ActivityCrewAssign = ({
  activity,
  handleOpenTaskDetail,
}: {
  activity: any;
  handleOpenTaskDetail?: (taskId: string) => void;
}) => {
  const tActivityCards = useTranslation('activityCards');

  const rightLabel = (
    <div className="flex gap-1">
      <GroupsOutlinedIcon fontSize="small" className="text-blue-500" />
      <p className="text-sm text-blue-500">{tActivityCards.crewAssign.crewAssigned}</p>
      <div className="flex gap-1">
        <p className="text-sm text-neutral-500">{`- ${formatActivityTime(activity.createdAt)}`}</p>
      </div>
    </div>
  );

  return (
    <Card key={activity.activityId} className="w-full">
      <ActivityHeader activity={activity} rightLabel={rightLabel} />

      <div className="flex gap-1 mt-2">
        <TaskName
          task={activity.task}
          taskId={activity.taskId || activity.task?.taskId}
          onOpenTask={handleOpenTaskDetail}
        />
      </div>

      <div className="flex gap-2 w-full">
        <div className="flex flex-col flex-1 gap-2">
          <Alert className="mt-2">
            <div className="flex flex-col gap-1">
              <div className="flex gap-1">
                <p className="text-sm text-neutral-800 font-semibold">
                  {tActivityCards.projectLabel}
                </p>
                <p className="text-sm text-neutral-800">
                  {activity.project?.name || tActivityCards.notAvailable}
                </p>
              </div>
            </div>
          </Alert>

          <Alert variant="info" className="h-full" border>
            <div className="flex items-center gap-1">
              <GroupsOutlinedIcon
                fontSize="small"
                className="text-blue-950 -mt-1"
              />
              <p className="text-sm text-blue-950 font-semibold">
                {activity.name || activity.description}
              </p>
            </div>
          </Alert>
        </div>
      </div>
    </Card>
  );
};
